import httpService from '@Utils/httpService';

//const dataApi = 'api/data';
const baseUrl = 'api/TaskStatuses';

export default {
  get(params) {
    return httpService.get({
      url: baseUrl,
      params,
    });
  },
  getById(id) {
    return httpService.get({
      url: `${baseUrl}/${id}`,
    });
  },
  update(data) {
    if (!data.id) return this.add(data);
    return httpService.put({
      url: `${baseUrl}/${data.id}`,
      data,
    });
  },
  add(data) {
    return httpService.post({
      url: baseUrl,
      data,
    });
  },
  addOrUpdate(data, isNew) {
    if (isNew)
      return httpService.post({
        url: baseUrl,
        data,
      });
    else {
      return httpService.put({
        url: `${baseUrl}/${data.id}`,
        data,
      });
    }
  },

  del(id) {
    return httpService.delete({
      url: `${baseUrl}/${id}`,
    });
  },

  getDatesStatus() {
    return httpService.get({
      url: `${baseUrl}/dates-status`,
    });
  }
};
